import {Injectable} from "@angular/core";
import {LocalizeRouterService} from "@gilsdav/ngx-translate-router";
import {IsActiveMatchOptions, NavigationExtras, Router, UrlTree} from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class LocalizedRouter {

    constructor(
        private router: Router,
        private localizeRouterService: LocalizeRouterService,
    ) { }

    navigate(commands: any[], extras?: NavigationExtras | undefined): Promise<boolean> {
        return this.router.navigate(this.translateCommands(commands), extras);
    }

    navigateByUrl(url: string) {
        const translatedRoute = this.translateUrl(url)
        return this.router.navigateByUrl(translatedRoute);
    }

    createUrlTree(commands: any[], extras?: NavigationExtras | undefined): UrlTree {
        return this.router.createUrlTree(this.translateCommands(commands), extras)
    }

    private translateCommands(commands: any[]): any[] {
        return [...this.localizeRouterService.translateRoute(commands)]
    }

    private translateUrl(path: string) {
        const translatedPath = this.localizeRouterService.parser.translateRoute(path);
        return this.localizeRouterService.parser.addPrefixToUrl(translatedPath);
    }

    createTranslatedRouteString(path: any[]): string {
        return this.router.serializeUrl(this.createUrlTree(path))
    }

    /**
     * Parses a string into a translated UrlTree
     * @param url
     */
    parseUrl(url: string): UrlTree {
        const translatedUrl = this.translateUrl(url);
        return this.router.parseUrl(translatedUrl)
    }

    /**
     * Returns whether the url is activated.
     */
    isActive(url: UrlTree, options: IsActiveMatchOptions): boolean {
        return this.router.isActive(url, options)
    }

}
